<template>
	<div class="products-list">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h3>UPDATE PRODUCTS</h3>

		<div class="productExport">
			<input type="file" @change="loadTextFromFile" />
		</div>

		{{ progress }} of {{ product_total }}

		<div>
			<ul>
				<li v-for="(error, index) in errors" :key="index" class="update-error">
					{{ error }}
				</li>
			</ul>
		</div>
		<!-- <div v-if="progress > 0" class="progress-bar">
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div> -->
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'productsList',
	data: function() {
		return {
			isLoading: false,
			progress: 0,
			product_total: 0,
			batchSize: 100,
			errors: [],

			idIndex: null,
			priceIndex: null,
			stockIndex: null,
			statusIndex: null,
			bdCodeIndex: null,
			barcodeIndex: null,
			nameIndex: null,
			productCodeIndex: null,
			brandIndex: null,
			commissionIndex: null,
			originalPriceIndex: null,
			authorIndex: null,
			// New packaging field indexes
			originalPriceUnitIndex: null,
			packagingBaseUnitIndex: null,
			boxPriceIndex: null,
			boxCardsIndex: null,
			cardPriceIndex: null,
			cardPillsIndex: null,
			pillPriceIndex: null
		}
	},

	mounted: async function() {},

	computed: {},

	methods: {
		async loadTextFromFile(ev) {
			this.isLoading = true
			this.progress = 0
			const file = ev.target.files[0]
			const reader = new FileReader()

			reader.onload = async event => {
				var raw = event.target.result.split(/\r?\n/)

				var header = raw[0].split(/,/)

				this.idIndex = header.indexOf('_id')
				if (this.idIndex == -1) {
					this.$swal.fire('Missing header "_id"!')

					this.isLoading = false

					return
				}

				this.priceIndex = header.indexOf('price')
				if (this.priceIndex == -1) {
					this.$swal.fire('Missing header "price"!')

					this.isLoading = false

					return
				}

				this.stockIndex = header.indexOf('stock')
				if (this.stockIndex == -1) {
					this.$swal.fire('Missing header "stock"!')

					this.isLoading = false

					return
				}

				this.statusStatus = header.indexOf('status')
				if (this.statusStatus == -1) {
					this.$swal.fire('Missing header "status"!')

					this.isLoading = false

					return
				}

				this.bdCodeIndex = header.indexOf('bd_code')
				if (this.bdCodeIndex == -1) {
					this.$swal.fire('Missing header "bd_code"!')

					this.isLoading = false

					return
				}

				this.barcodeIndex = header.indexOf('barcode')
				if (this.barcodeIndex == -1) {
					this.$swal.fire('Missing header "barcode"!')

					this.isLoading = false

					return
				}

				this.nameIndex = header.indexOf('name')
				if (this.nameIndex == -1) {
					this.$swal.fire('Missing header "name"!')

					this.isLoading = false

					return
				}

				this.productCodeIndex = header.indexOf('product_code')
				if (this.productCodeIndex == -1) {
					this.$swal.fire('Missing header "product_code"!')

					this.isLoading = false

					return
				}

				this.brandIndex = header.indexOf('brand')
				if (this.brandIndex == -1) {
					this.$swal.fire('Missing header "brand"!')

					this.isLoading = false

					return
				}

				this.commissionIndex = header.indexOf('commission')
				if (this.commissionIndex == -1) {
					this.$swal.fire('Missing header "commission"!')

					this.isLoading = false

					return
				}

				this.originalPriceIndex = header.indexOf('original_price')
				if (this.originalPriceIndex == -1) {
					this.$swal.fire('Missing header "original_price"!')

					this.isLoading = false

					return
				}

				this.authorIndex = header.indexOf('author')
				if (this.authorIndex == -1) {
					this.$swal.fire('Missing header "author"!')

					this.isLoading = false

					return
				}

				// Get new packaging field indexes (optional fields - no error if missing)
				this.originalPriceUnitIndex = header.indexOf('original_price_unit')
				this.packagingBaseUnitIndex = header.indexOf('packaging_base_unit')
				this.boxPriceIndex = header.indexOf('box_price')
				this.boxCardsIndex = header.indexOf('box_cards')
				this.cardPriceIndex = header.indexOf('card_price')
				this.cardPillsIndex = header.indexOf('card_pills')
				this.pillPriceIndex = header.indexOf('pill_price')

				// Remove first row
				raw.shift()

				// for total products
				this.product_total = raw.length - 1

				// Loop every row to put it in array
				for (let i = 0; i < raw.length; i += this.batchSize) {
					// prepare array to send to api
					const batch = raw.slice(i, i + this.batchSize)
					await this.processBatch(batch)
				}

				this.isLoading = false
			}

			reader.readAsText(file)
			this.isLoading = false
		},

		// prepare array to send to api
		async processBatch(batch) {
			let data = []

			this.progress += batch.length

			for (let product of batch) {
				if (product) {
					// split comma separated string into array
					// var splitData = product.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g)
					var splitData = product.split(/,(?=\S)/)

					// make sure data is not empty
					if (splitData[1]) {
						// Helper function to safely get CSV value or null
						const getValueOrNull = index => {
							if (
								index === -1 ||
								!splitData[index] ||
								splitData[index].trim() === '' ||
								splitData[index].trim() === 'null' ||
								splitData[index].trim() === 'undefined'
							) {
								return null
							}
							return splitData[index].trim()
						}

						// Build packaging object according to API schema
						let packaging = null
						const baseUnit = getValueOrNull(this.packagingBaseUnitIndex)
						const boxPrice = getValueOrNull(this.boxPriceIndex)
						const boxCards = getValueOrNull(this.boxCardsIndex)
						const cardPrice = getValueOrNull(this.cardPriceIndex)
						const cardPills = getValueOrNull(this.cardPillsIndex)
						const pillPrice = getValueOrNull(this.pillPriceIndex)

						// Check if any packaging field has actual data (not null)
						const hasValidBoxPrice = boxPrice !== null && !isNaN(parseFloat(boxPrice))
						const hasValidBoxCards = boxCards !== null && !isNaN(parseInt(boxCards))
						const hasValidCardPrice = cardPrice !== null && !isNaN(parseFloat(cardPrice))
						const hasValidCardPills = cardPills !== null && !isNaN(parseInt(cardPills))
						const hasValidPillPrice = pillPrice !== null && !isNaN(parseFloat(pillPrice))

						const hasPackagingData =
							baseUnit !== null || hasValidBoxPrice || hasValidBoxCards || hasValidCardPrice || hasValidCardPills || hasValidPillPrice

						// Only create packaging object if at least one field has actual data
						if (hasPackagingData) {
							packaging = {}

							// Set base_unit if provided
							if (baseUnit !== null) {
								packaging.base_unit = baseUnit
							}

							// Set box object only if price or cards have actual values
							if (hasValidBoxPrice || hasValidBoxCards) {
								packaging.box = {}
								if (hasValidBoxPrice) packaging.box.price = parseFloat(boxPrice)
								if (hasValidBoxCards) packaging.box.cards = parseInt(boxCards)
							}

							// Set card object only if price or pills have actual values
							if (hasValidCardPrice || hasValidCardPills) {
								packaging.card = {}
								if (hasValidCardPrice) packaging.card.price = parseFloat(cardPrice)
								if (hasValidCardPills) packaging.card.pills = parseInt(cardPills)
							}

							// Set pill object only if price has actual value
							if (hasValidPillPrice) {
								packaging.pill = {
									price: parseFloat(pillPrice)
								}
							}
						}

						let productData = {
							_id: splitData[this.idIndex],
							price: splitData[this.priceIndex],
							// stock: splitData[this.stockIndex],
							// status: splitData[this.statusStatus],
							bd_code: splitData[this.bdCodeIndex],
							barcode: splitData[this.barcodeIndex],
							name: splitData[this.nameIndex].replace(/"/g, ''),
							product_code: splitData[this.productCodeIndex],
							brand: splitData[this.brandIndex],
							commission: splitData[this.commissionIndex],
							original_price: splitData[this.originalPriceIndex],
							author: splitData[this.authorIndex],
							// New fields - always included even if null
							original_price_unit: getValueOrNull(this.originalPriceUnitIndex),
							packaging: packaging
						}

						data.push(productData)
					}
				}
			}

			await this.$api.updateForceProduct({ data: data })
		}
	}
}
</script>

<style scoped>
@import '../styles/ProductsList.css';
</style>
